import Swal from "sweetalert2";

/**
 * تأیید ترک یا اتمام آزمون — ظاهر یکدست با دیالوگ‌های آزمون (RTL، متن ساختاریافته).
 * هنگام تأیید، لودینگ روی دکمه تا پایان درخواست شبکه (جلوگیری از دوبار کلیک).
 * @param {{ isLeaveExam: boolean, onConfirm: () => void | Promise<void>, unansweredCount?: number }} opts
 */
export function showExamExitConfirmSwal({ isLeaveExam, onConfirm, unansweredCount = 0 }) {
    const finish = !isLeaveExam;
    const unanswered = Number(unansweredCount) > 0 ? Number(unansweredCount) : 0;
    const leaveHtml = `<div dir="rtl" style="text-align:right;font-size:15px;line-height:1.75;color:#334155;">
        <p style="margin:0;">می‌خواهید از محیط آزمون خارج شوید. <strong>پاسخ‌های ثبت‌شده تا این لحظه ذخیره می‌مانند.</strong></p>
    </div>`;
    const unansweredHtml = unanswered > 0
        ? `<p style="margin:0 0 10px;padding:10px 12px;background:#fff7ed;border:1px solid #fdba74;border-radius:8px;color:#9a3412;font-size:14px;">
            هنوز <strong>${unanswered}</strong> سوال بدون پاسخ دارید. با اتمام آزمون این سوال‌ها بدون پاسخ ثبت می‌شوند.
           </p>`
        : '';
    const finishHtml = `<div dir="rtl" style="text-align:right;font-size:15px;line-height:1.75;color:#334155;">
        ${unansweredHtml}
        <p style="margin:0 0 10px;">با تأیید، آزمون شما <strong>به‌صورت نهایی پایان</strong> می‌یابد.</p>
        <p style="margin:0;font-size:14px;color:#64748b;">امکان بازگشت به سوالات یا ادامهٔ آزمون پس از اتمام وجود ندارد. پاسخ‌هایی که قبلاً ثبت کرده‌اید حفظ می‌شوند.</p>
    </div>`;

    return Swal.fire({
        rtl: true,
        icon: finish ? "warning" : "question",
        iconColor: finish ? "#d97706" : "#64748b",
        title: isLeaveExam ? "ترک آزمون؟" : (unanswered > 0 ? "اتمام آزمون با سوال بی‌پاسخ؟" : "اتمام آزمون؟"),
        html: isLeaveExam ? leaveHtml : finishHtml,
        showCancelButton: true,
        confirmButtonText: isLeaveExam ? "بله، ترک آزمون" : "بله، اتمام آزمون",
        cancelButtonText: "انصراف",
        confirmButtonColor: isLeaveExam ? "#ea580c" : "#16a34a",
        cancelButtonColor: "#64748b",
        reverseButtons: true,
        focusCancel: finish,
        customClass: { popup: "exam-exit-dialog-popup" },
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: async () => {
            try {
                await onConfirm();
            } catch (err) {
                const raw = err?.message || 'خطا در برقراری ارتباط با سرور';
                const safe = String(raw)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');
                Swal.showValidationMessage(`<div dir="rtl" style="text-align:right">${safe}</div>`);
                return false;
            }
        },
    });
}
